<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="true" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.articleId == undefined && $route.params.articleNumber == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <SupplierSelect v-model="suppliersfilter" multiple clearable externaledit class="ma-3">
            </SupplierSelect>

            <v-row no-gutters justify="start" align="center" class="ma-3">
              <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.article.techniciansparepart") }}:</p>
              <TechnicianSparePartFilter :pk="pk"></TechnicianSparePartFilter>
            </v-row>

            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getArticleListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="75" :open-function="openItem" :pk="pk"
          :eventualDataType="eventualDataTypeKey">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" :showStoreItems="false" @click="openItem(item)" />
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import ListItem from "@/components/ListItems/ArticleListItem2.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import TechnicianSparePartFilter from "@/components/TechnicianSparePartFilter.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminArticles",
  props: {},
  components: {
    FilterPane,
    ListPane,
    Layout,
    ListItem,
    SupplierSelect,
    DefaultLifeCycleFilterGroup,
    TechnicianSparePartFilter,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "AL-",

    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "Articles") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewArticle', params: { articleId: item.Id, articleNumber: item.ArticleNumber }, query })
    },
  },

  computed: {
    eventualDataTypeKey() { return SRConst.EventualDataType.Article; },
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          SupplierIdList: this.suppliersfilter,
          IsTechnicianPart: this.getQueryParam("filter-technicianpart", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },
  },

  watch: {},
};
</script>